// extracted by mini-css-extract-plugin
module.exports = {"container":"pagination__container___3p_9K"};